export function accordions()
{
	const toggleOpen = (body, button) =>
	{
		body.classList.add('expanded');
		button.setAttribute('aria-expanded', true);
		const icon = button.querySelector('[data-accordion-icon]');
		if (icon)
		{
			icon.classList.add('expanded');
		}
		body.style.maxHeight = body.scrollHeight + 'px'; // added to animate opening
	};

	const toggleClosed = (body, button) =>
	{
		body.classList.remove('expanded');
		button.setAttribute('aria-expanded', false);
		const icon = button.querySelector('[data-accordion-icon]');
		if (icon)
		{
			icon.classList.remove('expanded');
		}
		body.style.maxHeight = null; // added to animate closing
	};

	const accordionButtons = document.querySelectorAll('[data-accordion-button]');

	if (!accordionButtons.length) return;

	accordionButtons.forEach((button) =>
	{
		button.addEventListener('click', () =>
		{			
			const accordionBody = document.querySelector(
				`[data-accordion-body="${ button.dataset.accordionButton }"]`
			);

			const accordionGroup = button.dataset.accordionGroup;

			const accordionBodies = document.querySelectorAll('[data-accordion-body]');

			accordionBodies.forEach((body) =>
			{
				let bodyGroup = body.dataset.accordionGroupBody;
				
				if (body === accordionBody)
				{
					if (body.classList.contains('expanded'))
					{
						toggleClosed(body, button);
					} else
					{
						toggleOpen(body, button);
					}
				} else
				{

					if (bodyGroup === accordionGroup) 
					{
						toggleClosed(body, document.querySelector(`[data-accordion-button="${ body.dataset.accordionBody }"]`));
					}
				}
			});
		});
	});
}


// WEBPACK FOOTER //
// ./scripts/modules/accordions.js